module.exports = __webpack_public_path__ + "img/137.4245d27f.png";